import { useQuery, useMutation, useQueryClient } from '../lib/queryClient';
import { createInvitation } from '../endpoints/invitations/create_POST.schema';
import { acceptInvitation } from '../endpoints/invitations/accept_POST.schema';
import { getInvitationsList } from '../endpoints/invitations/list_GET.schema';

export const useInvitations = (sessionId: string | undefined) => {
  return useQuery({
    queryKey: ['invitations', 'list', sessionId],
    queryFn: () => {
      if (!sessionId) throw new Error('Session ID is required');
      return getInvitationsList({ sessionId });
    },
    enabled: !!sessionId,
  });
};

export const useCreateInvitation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createInvitation,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['invitations', 'list', variables.sessionId] });
    },
  });
};

export const useAcceptInvitation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: acceptInvitation,
    onSuccess: (data) => {
      // Invalidate session list as the user might now see a new session
      queryClient.invalidateQueries({ queryKey: ['sessions', 'list'] });
      // Also invalidate the specific session detail if we happen to be viewing it (unlikely flow but safe)
      queryClient.invalidateQueries({ queryKey: ['sessions', 'detail', data.session.id] });
    },
  });
};
